<div class="mt-4 p-2 mastrPlan" #meals>
    <p class="discover-week-menu">Discover This Week's Menu</p>
    <p class="fm-rubik mb-4" style="color: #494646;font-size: 16px;font-weight: 300;">
        Satisfy your cravings with over 60+ amazing meals, carefully curated for a week full of flavor.
    </p>
    <div class="container">
        <div class="">
            <swiper-container
                    slides-per-view="auto"
                    pagination="true"
                    [attr.pagination-clickable]="true"
                    space-between="10"
                    free-mode="true"
                    class="current-menu-swiper"
                    [attr.init]="false">
                    
                <swiper-slide *ngFor="let meal of mealsModel">
                    <app-new-meal-card [meal]="meal" [isCurrentMenu]="true" [showMealDetails]="false"/>
                </swiper-slide>
            </swiper-container>
        </div>
        <div class="mt-4 mb-4 web-center">
            <app-orange-button text="View Full Menu" (action)="goToCurrentMenu()" />
        </div>
    </div>
</div>
